// @flow
import * as React from 'react';

import type {
  FavoriteContact,
  ContactRole,
} from '@gandi/redux-resource-contactbook';
import { useTranslator } from '@gandi/translate';
import { Base } from '@gandi/ui';
import { ListItem, ListCell, ListRow } from '@gandi/ui/deprecated';

import { getDisplayedRole } from '../../../modules/helpers';
import type { CreateOrTransfer } from '../../../types';

import EmptyRoleContact from './EmptyRoleContact';
import RoleContact from './RoleContact';

import styles from './RoleContactCard.scss';

type Props = {
  role: ContactRole,
  contact?: ?FavoriteContact,
  process: CreateOrTransfer,
  owner?: FavoriteContact,
  readOnly: boolean,
};

function RoleContactCard({
  role,
  contact,
  process,
  owner,
  readOnly,
}: Props): React.MixedElement {
  const translator = useTranslator();
  const roleLabel = getDisplayedRole(translator, role);

  return (
    <Base marginBottom="base" className={styles.root}>
      <ListRow>
        <ListItem>
          <ListCell>{roleLabel}</ListCell>
        </ListItem>
      </ListRow>
      {contact && (
        <RoleContact
          process={process}
          contact={contact}
          role={role}
          readOnly={readOnly}
        />
      )}
      {!contact && (
        <EmptyRoleContact
          process={process}
          role={role}
          owner={owner}
          readOnly={readOnly}
        />
      )}
    </Base>
  );
}

export default (React.memo<Props>(RoleContactCard): React.ComponentType<Props>);
